import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=d6853a4a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6853a4a')) {
      api.createRecord('d6853a4a', component.options)
    } else {
      api.reload('d6853a4a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=d6853a4a&", function () {
      api.rerender('d6853a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Zea4E1k6xWmL/JS/imageCarousel.vue"
export default component.exports